








































































































































































import { Component, Prop, Ref, Watch } from 'vue-property-decorator'
import { HsComponent } from '@hds/help-common/src/components/hs-components'
import * as ConstantKey from '@hds/help-common/src/utils/constant-keys'
import * as ConstKeys from '../../utils/constant-keys'

@Component({
  name: 'HeaderBar',
})
export default class extends HsComponent {
  // #region variables
  @Prop({ default: 'page title' }) readonly pageTitle!: string | boolean
  @Prop({ default: 'type1' }) readonly headerLayoutType!: string

  systemListExpand = false
  searchMenuDialog = false
  searchMenuField = null
  favoritePage = false
  headerHeight = ConstKeys.APP_BAR_HEIGHT
  visible = true
  localAuthChk = false

  isDev = false
  isProduction = false

  // 메뉴검색관련
  totalSysTrees = []

  get systemAliasName() {
    return this.$ustra.hs.store.cmData.appProp.systemAliasName ? this.$ustra.hs.store.cmData.appProp.systemAliasName : '시스템 별칭'
  }

  get currentMenu() {
    const currentMenu = this.$ustra.hs.store.menuData.currentMenu
    if (!currentMenu) return { fav: false }

    const fav = !!this.$ustra.hs.store.menuData.myMenus.find((m) => m.menuId === currentMenu.menuId)

    return { ...currentMenu, fav }
  }

  get gnbItems() {
    if (this.$ustra.hs.store.auth.currentUser.userGbcd === ConstantKey.ADMIN_ROLE) {
      return this.$ustra.hs.store.menuData.rawMenus
    } else {
      return this.$ustra.hs.store.menuData.rawMenus.filter((m) => (m.prgUrl !== undefined ? !m.prgUrl.startsWith('/beqmt') : true))
    }
  }

  get hideOnScroll() {
    return this.headerLayoutType === 'type1'
  }

  get accessToken() {
    return this.$ustra.auth.store.accessToken
  }

  get refreshToken() {
    return this.$ustra.auth.store.refreshToken
  }

  created() {
    console.log('env:', process.env.CONFIG_ENV)
    if (process.env.CONFIG_ENV === 'production') {
      this.isDev = false
      this.isProduction = true
    } else {
      this.isDev = true
      this.isProduction = false
    }
    this.totalSysTree()
    if (this.$ustra.hs.store.auth.currentUser.userGbcd === ConstantKey.ADMIN_ROLE) {
      this.localAuthChk = true
    } else {
      this.localAuthChk = false
    }
  }

  home() {
    // this.$ustra.router.push('/')
    location.href = '/'
  }

  link(url: string, type: 'webview' | 'browser') {
    // 웹뷰로 전달
    if (type === 'webview') {
      const accessToken = this.accessToken
      const refreshToken = this.refreshToken
      this.$ustra.mobile.bridge.callNative({
        id: 'IF_COMMON',
        data: {
          type: '04',
          url,
          accessToken,
          refreshToken,
        },
      })
    } else if (type === 'browser') {
      const accessToken = this.accessToken
      const refreshToken = this.refreshToken
      this.$ustra.mobile.bridge.callNative({
        id: 'IF_COMMON',
        data: {
          type: '05',
          url,
          accessToken,
          refreshToken,
        },
      })
    } else {
      // @ts-ignore
      this.$refs.form.action = url
      // @ts-ignore
      this.$refs.form.submit()
    }
  }

  // 검색 키워드 하이라이트
  highlightKeyword(menuName) {
    if (menuName == null) return
    const check = new RegExp(this.searchMenuField, 'ig')
    const highLight = menuName.toString().replace(check, function (matchedText, a, b) {
      return '<span class="primary--text">' + matchedText + '</span>'
    })
    return highLight
  }

  // 검색시 트리 오픈
  @Ref() sysTree
  onInputSearchMenu(value) {
    if (value) {
      this.sysTree.updateAll(true)
    } else {
      this.sysTree.updateAll(false)
    }
  }

  // 메뉴검색 아이템 클릭
  onClickSearchMenuItem(url) {
    this.$router.push(url)
    this.searchMenuDialog = false
    this.searchMenuField = null
    this.sysTree.updateAll(false)
  }

  /**
   *  시스템 메뉴 리스트 2차원 배열 정리
   *
   * totalSysTrees = [{
   *  id: 시스템아이디,
   *  name: 시스템명,
   *  children: [{id: 메뉴아이디, name: 메뉴아이디, prgUrl: 메뉴url},...]
   * },...]
   */
  totalSysTree() {
    for (const menu of this.gnbItems) {
      if (menu.isleaf === '0') continue
      let isFlag = false
      for (let index = 0; index < this.totalSysTrees.length; index++) {
        if (this.totalSysTrees[index].id === menu.sysGbcd) {
          const tempItems = {
            id: menu.menuId,
            name: menu.menuNm,
            prgUrl: menu.prgUrl,
          }
          this.totalSysTrees[index].children.push(tempItems)
          isFlag = true
          break
        }
      }

      if (!isFlag) {
        const tempItems = {
          id: menu.menuId,
          name: menu.menuNm,
          prgUrl: menu.prgUrl,
        }
        const tempGroup = {
          id: menu.sysGbcd,
          name: menu.sysGbnm === undefined ? '모바일HELP' : '',
          children: [],
        }
        tempGroup.children.push(tempItems)
        this.totalSysTrees.push(tempGroup)
      }
    }
  }

  back() {
    // this.$ustra.router.back()
    window.history.back()
  }

  outSideinclude() {
    return [document.querySelector('.hs-system-list--wrap')]
  }

  onSystemExpandOutside() {
    this.systemListExpand = false
    document.documentElement.classList.remove('overflow-y-hidden')
  }

  onClickSystemListExpand() {
    if (this.systemListExpand) {
      this.systemListExpand = false
      document.documentElement.classList.remove('overflow-y-hidden')
    } else {
      this.systemListExpand = true
      document.documentElement.classList.add('overflow-y-hidden')
    }
  }

  // #endregion
  // #region watches
  @Watch('headerLayoutType')
  changedHeaderLayoutType() {
    this.visible = true
  }
  // #endregion

  goBeqmt() {
    location.href = '/beqmt/brodMain'
  }

  goExt() {
    location.href = '/ext/esIndex'
  }
}
